import React, { FC, useContext, useMemo } from 'react';
import { Button, Loader } from 'ncoded-component-library';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import UploadIcon from 'icons/Upload.icon';
import EnterpriseMembersContext from 'providers/EnterpriseMembers/EnterpriseMembers.context';
import AddProfileIcon from 'icons/AddProfile.icon';
import AddBulkMembersModal from './AddBulkMembersModal';
import { ModalRef } from 'ncoded-component-library/build/components/organisms/Modal/Modal.component';
import useCallbackRef from 'hooks/useCallbackRef';
import NumberOfResultsPerPageFilter from 'components/NumberOfResultsPerPageFilter';

import './ManagePeopleActions.styles.scss';
import './ManagePeopleActions.styles.responsive.scss';

export type ManagePeopleActionsProps = {
  className?: string;
  showLimit?: boolean;
};

const ManagePeopleActions: FC<ManagePeopleActionsProps> = (props) => {
  const { className, showLimit } = props;

  const { isLoadingAddMember, limit, handleAddPeople, updateLimit } =
    useContext(EnterpriseMembersContext);

  const [modal, modalRef] = useCallbackRef<ModalRef>();

  const isLoading = useMemo(() => isLoadingAddMember, [isLoadingAddMember]);

  const classes = classNames('manage-people-actions', className);

  const { t } = useTranslation();

  return (
    <>
      <div className={classes}>
        {showLimit && (
          <NumberOfResultsPerPageFilter
            limit={limit}
            updateLimit={updateLimit}
          />
        )}

        <Button icon={UploadIcon} disabled={isLoading} onClick={modal?.open}>
          {t('addMembersInBulk')}
        </Button>

        <Button
          variant="outline"
          disabled={isLoading}
          icon={AddProfileIcon}
          onClick={handleAddPeople}
        >
          {isLoadingAddMember && <Loader size="small" />}
          {t('addMember')}
        </Button>
      </div>
      <AddBulkMembersModal ref={modalRef} />
    </>
  );
};

export default ManagePeopleActions;
